// extracted by mini-css-extract-plugin
export default {"underlay":"components-Modal-styles-module__underlay--RcP6w","mounted":"components-Modal-styles-module__mounted--q_CtJ","modal":"components-Modal-styles-module__modal--uNtJ8"};